// extracted by mini-css-extract-plugin
module.exports = {"textLink":"text-link_textLink__vMJRU","textLinkUnderlined":"text-link_textLinkUnderlined__OKhjI"};